import styled from "styled-components";


export const Container = styled.div`
    display: grid;
    padding: 1rem;
`;

export const ProfileImg = styled.img`
    object-fit: cover;
    width: 20rem;
    height: 20rem;
    
`;

export const ProfileInfo = styled.div`
    width: 20rem;
    grid-row: 2;
    min-height: 5.6rem;
    background: rgba(0, 0, 0, 0.6);
`;

export const ProfileName = styled.p`
    color: var(--mainLetters);
    font-size: 1.2rem;
`;

export const ProfileFormation = styled.p`
    font-size: 1rem;
    color: var(--mainLetters);
`;

export const ProfileLinks = styled.div`
    display: flex;
    justify-content: space-around;
`;

export const GithubImg = styled.a`
    img{
        width: 24px;
    }
`;

export const LinkedinImg = styled.a`
    img{
        width: 24px;
    }
`;

export const CvLink = styled.a`
    img{
        width: 24px;
    }
`;
